import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../../components/ui/alert-dialog";

export const DeleteOrdersDialog = ({ open, count, onCancel, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
    <AlertDialogContent className="rounded-none bg-[var(--cream)]" data-testid="admin-orders-delete-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-serif-display text-2xl font-normal">Delete {count} order(s)?</AlertDialogTitle>
        <AlertDialogDescription>
          These unpaid orders will be removed permanently. Paid orders can never be deleted.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="admin-orders-delete-cancel" className="rounded-none">Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} data-testid="admin-orders-delete-confirm" className="rounded-none bg-red-700 hover:bg-red-800">Delete</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
